// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"331b3aff","206":"66ef4d7c","814":"b1cb220d"}[chunkId] + ".chunk.css";
};